"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4044],{

/***/ 34044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G7": function() { return /* binding */ TABS; },
/* harmony export */   "ND": function() { return /* binding */ SERIES_ID; },
/* harmony export */   "WD": function() { return /* binding */ IPLTABS; },
/* harmony export */   "YF": function() { return /* binding */ SERIES_ID_IPL; },
/* harmony export */   "ZW": function() { return /* binding */ IPL_YEAR; },
/* harmony export */   "ek": function() { return /* binding */ IPL; },
/* harmony export */   "iu": function() { return /* binding */ TEAMS_OBJ; },
/* harmony export */   "ut": function() { return /* binding */ callGaEvent; },
/* harmony export */   "v": function() { return /* binding */ goToMatchDetails; }
/* harmony export */ });
/* unused harmony exports OLD_BASE_URL, NEW_BASE_URL, APIS, APISIPL, IPL_DISPLAY_YEAR, getMatchDetails, IPLLANDING, TEAMS, VS_LINK, VALID_YEARS, VALID_CATEGORIES */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var TABS = [{
  display: "ओवरव्यू",
  page: "overview",
  url: "",
  keyToShow: ""
}, {
  display: "पॉइंट्स टेबल",
  page: "points-table",
  url: "points-table",
  keyToShow: ""
}, {
  display: "शेड्यूल",
  page: "matches",
  url: "schedule",
  keyToShow: ""
}, {
  display: "स्टैट्‍स",
  page: "stats",
  url: "stats",
  keyToShow: "ShowStats"
}];
var OLD_BASE_URL = 'https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web';
var NEW_BASE_URL = 'http://sintaks.simpleapi.itgd.in/cricket/feeds/api/feeds/index.php/scorecard';
var SERIES_ID = 8322;
var APIS = {
  // matches : {
  //     live  : "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/livematch_list/hn_json/",
  //     upcoming :  "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/league_by_series_matchtype/8322_upcoming_hn_json/",
  //     recent  : "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/league_by_series_matchtype/8322_recent___hn_json/",
  // },
  matches: {
    live: "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/livematch_list/hn_json/",
    upcoming: "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/league_by_series_matchtype/8322_upcoming_hn_json/",
    recent: "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/league_by_series_matchtype/8322_recent_hn_json/"
  } //   matches : {
  //     live  : "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/livematch_list/hn_json/123",
  //     upcoming :  "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/league_by_series_matchtype/8322_upcoming_hn_json/123",
  //     recent  : "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/league_by_series_matchtype/8322_recent_hn_json/123",
  // }

}; // 5970
// 8307
// export const SERIES_ID_IPL = 12569

var SERIES_ID_IPL = 8307; // export const SERIES_ID_IPL = 10382

var APISIPL = {
  matches: {
    live: NEW_BASE_URL + "/livematch_list/hn/json",
    upcoming: NEW_BASE_URL + "/league_by_series_matchtype/8307/upcoming/hn/json",
    recent: NEW_BASE_URL + "/league_by_series_matchtype/8307/recent/hn/json",
    pointsTable: NEW_BASE_URL + "/series_standings/8307/hn/json",
    teams: NEW_BASE_URL + '/team_by_series/all/8307/1/10/hn/json'
  } //   matches : {
  //     live  : NEW_BASE_URL +  "/livematch_list/hn/json",
  //     upcoming :  NEW_BASE_URL +  "/league_by_series_matchtype/12569/upcoming/hn/json",
  //     recent  : NEW_BASE_URL +  "/league_by_series_matchtype/12569/recent/hn/json",
  //     pointsTable : NEW_BASE_URL+  `/series_standings/12569/hn/json`,
  //     teams : NEW_BASE_URL +  '/team_by_series/all/12569/1/10/hn/json'
  // }
  //   matches : {
  //     live  : "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/livematch_list/hn_json/",
  //     upcoming :  "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/league_by_series_matchtype/9093_upcoming_hn_json/",
  //     recent  : "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/league_by_series_matchtype/9093_recent_hn_json/",
  //     pointsTable : `https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/series_standings/9093_hn_json`,
  //     teams : 'https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/team_by_series/all_9093_1_10_hn_json/'
  // }
  //   matches : {
  //     live  : "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/livematch_list/hn_json/",
  //     upcoming :  "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/league_by_series_matchtype/5970_upcoming_hn_json/",
  //     recent  : "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/league_by_series_matchtype/5970_recent_hn_json/",
  //     pointsTable : `https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/series_standings/5970_hn_json`,
  //     teams : 'https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/team_by_series/all_5970_1_10_hn_json/'
  // }
  //   matches : {
  //     live  : "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/livematch_list/hn_json/123",
  //     upcoming :  "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/league_by_series_matchtype/8322_upcoming_hn_json/123",
  //     recent  : "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/league_by_series_matchtype/8322_recent_hn_json/123",
  // }

};
var IPLTABS = [{
  displayName: "होम",
  url: '/sports/ipl',
  id: "home",
  gaEvent: "Home_click"
}, {
  displayName: "पॉइंट्स टेबल",
  url: '/sports/ipl/points-table',
  id: "points-table",
  gaEvent: "Points Table_click"
}, {
  displayName: "शेड्यूल",
  url: '/sports/ipl/schedule',
  id: "matches",
  gaEvent: "Schedule_click"
}, {
  displayName: "स्टैट्स",
  url: '/sports/ipl/stats',
  id: "tracker",
  gaEvent: "IPL Tracker_click"
}, {
  displayName: "ऑरेंज कैप",
  url: '/sports/ipl/orange-cap-winner',
  id: "orange",
  gaEvent: "IPL Tracker_click"
},, {
  displayName: "पर्पल कैप",
  url: '/sports/ipl/purple-cap-winner',
  id: "purple",
  gaEvent: "IPL Tracker_click"
}];
var IPL_YEAR = 2024;
var IPL_DISPLAY_YEAR = 2025;
var goToMatchDetails = /*#__PURE__*/function () {
  var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(matchId, series) {
    var _response$data, _fetchedData$data, _fetchedData$data$res, _fetchedData$data$res2, _fetchedData$data$res3;

    var response, fetchedData, _fetchedData$data2, _fetchedData$data2$re, data, page;

    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios__WEBPACK_IMPORTED_MODULE_2___default().get("".concat("https://www.thelallantop.com", "/api/getRecentMatch?id=").concat(matchId, "&nocache=").concat(new Date().getTime()));

          case 2:
            response = _context.sent;
            fetchedData = (_response$data = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data !== void 0 ? _response$data : null;

            if ((fetchedData === null || fetchedData === void 0 ? void 0 : (_fetchedData$data = fetchedData.data) === null || _fetchedData$data === void 0 ? void 0 : (_fetchedData$data$res = _fetchedData$data.response) === null || _fetchedData$data$res === void 0 ? void 0 : (_fetchedData$data$res2 = _fetchedData$data$res.scorecard) === null || _fetchedData$data$res2 === void 0 ? void 0 : (_fetchedData$data$res3 = _fetchedData$data$res2.match_Id) === null || _fetchedData$data$res3 === void 0 ? void 0 : _fetchedData$data$res3.length) > 0) {
              data = fetchedData === null || fetchedData === void 0 ? void 0 : (_fetchedData$data2 = fetchedData.data) === null || _fetchedData$data2 === void 0 ? void 0 : (_fetchedData$data2$re = _fetchedData$data2.response) === null || _fetchedData$data2$re === void 0 ? void 0 : _fetchedData$data2$re.scorecard;
              page = null;

              if (data.is_live == 1) {
                page = 'live';
              } else if (data.upcoming == 1) {
                page = 'info';
              } else {
                page = 'summary';
              }

              if (series == 'ipl') {
                window.location.href = "/sports/ipl/".concat(data === null || data === void 0 ? void 0 : data.page_slug_st, "/stats/").concat(page);
              } else if (series == 'ct') {
                window.location.href = "/sports/cricket/champions-trophy/".concat(data === null || data === void 0 ? void 0 : data.page_slug_st, "/stats/").concat(page);
              }
            }

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function goToMatchDetails(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var getMatchDetails = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(matchId) {
    var _response$data2, _fetchedData$data3, _fetchedData$data3$re, _fetchedData$data3$re2, _fetchedData$data3$re3;

    var response, fetchedData, _fetchedData$data4, _fetchedData$data4$re, data;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return axios.get("".concat("https://www.thelallantop.com", "/api/getRecentMatch?id=").concat(matchId, "&nocache=").concat(new Date().getTime()));

          case 2:
            response = _context2.sent;
            fetchedData = (_response$data2 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data2 !== void 0 ? _response$data2 : null;

            if (!((fetchedData === null || fetchedData === void 0 ? void 0 : (_fetchedData$data3 = fetchedData.data) === null || _fetchedData$data3 === void 0 ? void 0 : (_fetchedData$data3$re = _fetchedData$data3.response) === null || _fetchedData$data3$re === void 0 ? void 0 : (_fetchedData$data3$re2 = _fetchedData$data3$re.scorecard) === null || _fetchedData$data3$re2 === void 0 ? void 0 : (_fetchedData$data3$re3 = _fetchedData$data3$re2.match_Id) === null || _fetchedData$data3$re3 === void 0 ? void 0 : _fetchedData$data3$re3.length) > 0)) {
              _context2.next = 7;
              break;
            }

            data = fetchedData === null || fetchedData === void 0 ? void 0 : (_fetchedData$data4 = fetchedData.data) === null || _fetchedData$data4 === void 0 ? void 0 : (_fetchedData$data4$re = _fetchedData$data4.response) === null || _fetchedData$data4$re === void 0 ? void 0 : _fetchedData$data4$re.scorecard;
            return _context2.abrupt("return", data);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getMatchDetails(_x3) {
    return _ref2.apply(this, arguments);
  };
}())); //apis for tracker

var IPL = {
  APIS: {
    orangeCap: NEW_BASE_URL + "/series_player_stats/5970/2/json",
    purpleCap: NEW_BASE_URL + "/series_player_stats/5970/13/json",
    // iplNumbers : "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/series_player_stats/5970_en_json/",
    iplNumbers: NEW_BASE_URL + "/series_player_team_stats/5970/en/json",
    mostDismissals: NEW_BASE_URL + "/series_player_stats/5970/21/json",
    allStats: NEW_BASE_URL + "/series_player_stats/5970/0/json"
  },
  APIS2025: {
    orangeCap: NEW_BASE_URL + "/series_player_stats/8307/2/json",
    purpleCap: NEW_BASE_URL + "/series_player_stats/8307/13/json",
    // iplNumbers : "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/series_player_stats/8307_en_json/",
    iplNumbers: NEW_BASE_URL + "/series_player_team_stats/8307/en/json",
    mostDismissals: NEW_BASE_URL + "/series_player_stats/8307/21/json",
    allStats: NEW_BASE_URL + "/series_player_stats/8307/0/json"
  },
  APISCSR: {
    orangeCap: NEW_BASE_URL + "/series_player_stats/",
    purpleCap: NEW_BASE_URL + "/series_player_stats/",
    iplNumbers: NEW_BASE_URL + "/series_player_team_stats/",
    mostDismissals: NEW_BASE_URL + "/series_player_stats/",
    allStats: NEW_BASE_URL + "/series_player_stats/"
  },
  ORANGE_CAP_YEARS: [{
    "year": "2025",
    "url": "orange-cap-winner"
  }, {
    "year": "2024",
    "url": "orange-cap-winner-2024"
  }, {
    "year": "2023",
    "url": "orange-cap-winner-2023"
  }, {
    "year": "2022",
    "url": "orange-cap-winner-2022"
  }, {
    "year": "2021",
    "url": "orange-cap-winner-2021"
  }, {
    "year": "2020",
    "url": "orange-cap-winner-2020"
  }, {
    "year": "2019",
    "url": "orange-cap-winner-2019"
  }, {
    "year": "2018",
    "url": "orange-cap-winner-2018"
  }],
  PURPLE_CAP_YEARS: [{
    "year": "2025",
    "url": "purple-cap-winner"
  }, {
    "year": "2024",
    "url": "purple-cap-winner-2024"
  }, {
    "year": "2023",
    "url": "purple-cap-winner-2023"
  }, {
    "year": "2022",
    "url": "purple-cap-winner-2022"
  }, {
    "year": "2021",
    "url": "purple-cap-winner-2021"
  }, {
    "year": "2020",
    "url": "purple-cap-winner-2020"
  }, {
    "year": "2019",
    "url": "purple-cap-winner-2019"
  }, {
    "year": "2018",
    "url": "purple-cap-winner-2018"
  }],
  YEARS2025: {
    '2025': "8307",
    '2024': '5970',
    '2023': '5157',
    '2022': '4623',
    '2021': '4165',
    '2020': '3978',
    '2019': '3130',
    '2018': '2940'
  },
  YEARS: {
    '2025': "8307",
    '2024': '5970',
    '2023': '5157',
    '2022': '4623',
    '2021': '4165',
    '2020': '3978',
    '2019': '3130',
    '2018': '2940'
  },
  DEFAULT_YEAR: '2024'
}; //apis for landing page

var IPLLANDING = {
  APIS: {
    orangeCap: NEW_BASE_URL + "/series_player_stats/8307/2/json",
    purpleCap: NEW_BASE_URL + "/series_player_stats/8307/13/json",
    iplNumbers: NEW_BASE_URL + "/series_player_team_stats/8307/en/json",
    mostDismissals: NEW_BASE_URL + "/series_player_stats/8307/21/json",
    allStats: NEW_BASE_URL + "/series_player_stats/8307/0/json"
  },
  // APIS: {
  //   orangeCap: "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/series_player_stats/5970_2_json/",
  //   purpleCap: "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/series_player_stats/5970_13_json/",
  //   iplNumbers: "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/series_player_team_stats/5970_en_json/",
  //   mostDismissals: "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/series_player_stats/5970_21_json/",
  //   allStats: "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/series_player_stats/5970_0_json/"
  // },
  // APISCSR: {
  //   orangeCap: "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/series_player_stats/",
  //   purpleCap: "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/series_player_stats/",
  //   iplNumbers: "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/series_player_stats/",
  //   mostDismissals: "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/series_player_stats/",
  //   allStats: "https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/series_player_stats/"
  // },
  YEARS: {
    '2025': '8307',
    '2024': '5970',
    '2023': '5157',
    '2022': '4623',
    '2021': '4165',
    '2020': '3978',
    '2019': '3130',
    '2018': '2940'
  },
  DEFAULT_YEAR: '2025'
}; //teams  of ipl

var TEAMS = [{
  name: "CSK",
  logo: "https://static.thelallantop.com/images/post/1742205571781_15.webp"
}, {
  name: "DC",
  logo: "https://static.thelallantop.com/images/post/1742282146218_11.webp"
}, {
  name: "GT",
  logo: "https://static.thelallantop.com/images/post/1742282219923_16.webp"
}, {
  name: "KKR",
  logo: "https://static.thelallantop.com/images/post/1742282236086_17.webp"
}, {
  name: "LSG",
  logo: "https://static.thelallantop.com/images/post/1742282347027_18.webp"
}, {
  name: "MI",
  logo: "https://static.thelallantop.com/images/post/1742282365310_19.webp"
}, {
  name: "PBKS",
  logo: "https://static.thelallantop.com/images/post/1742285320809_20.webp"
}, {
  name: "RR",
  logo: "https://static.thelallantop.com/images/post/1742285364172_21.webp"
}, {
  name: "RCB",
  logo: "https://static.thelallantop.com/images/post/1742285377322_22.webp"
}, {
  name: "SRH",
  logo: "https://static.thelallantop.com/images/post/1742285394158_23.webp"
}]; // export const TEAMS_OBJ = {
//   "चेन्नई सुपर किंग्स": "https://static.thelallantop.com/images/post/1742889365535_15-min.webp",
//   "चेन्नई": "https://static.thelallantop.com/images/post/1742889365535_15-min.webp",
//   "Chennai": "https://static.thelallantop.com/images/post/1742889365535_15-min.webp",
//   "CSK": "https://static.thelallantop.com/images/post/1742889365535_15-min.webp",
//   "दिल्ली कैपिटल्स": "https://static.thelallantop.com/images/post/1742889348872_11-min.webp",
//   "दिल्ली": "https://static.thelallantop.com/images/post/1742889348872_11-min.webp",
//   "Delhi": "https://static.thelallantop.com/images/post/1742889348872_11-min.webp",
//   "DC": "https://static.thelallantop.com/images/post/1742889348872_11-min.webp",
//   "गुजरात टाइटन्स": "https://static.thelallantop.com/images/post/1742889380124_16-min.webp",
//   "गुजरात": "https://static.thelallantop.com/images/post/1742889380124_16-min.webp",
//   "Gujarat": "https://static.thelallantop.com/images/post/1742889380124_16-min.webp",
//   "GT": "https://static.thelallantop.com/images/post/1742889380124_16-min.webp",
//   "कोलकाता नाइट राइडर्स": "https://static.thelallantop.com/images/post/1742889392428_17-min.webp",
//   "कोलकाता": "https://static.thelallantop.com/images/post/1742889392428_17-min.webp",
//   "Kolkata": "https://static.thelallantop.com/images/post/1742889392428_17-min.webp",
//   "KKR": "https://static.thelallantop.com/images/post/1742889392428_17-min.webp",
//   "लखनऊ सुपर जायंट्स": "https://static.thelallantop.com/images/post/1742889403447_18-min.webp",
//   "लखनऊ": "https://static.thelallantop.com/images/post/1742889403447_18-min.webp",
//   "Lucknow": "https://static.thelallantop.com/images/post/1742889403447_18-min.webp",
//   "LSG": "https://static.thelallantop.com/images/post/1742889403447_18-min.webp",
//   "मुंबई इंडियंस": "https://static.thelallantop.com/images/post/1742889442176_19-min.webp",
//   "मुंबई": "https://static.thelallantop.com/images/post/1742889442176_19-min.webp",
//   "Mumbai": "https://static.thelallantop.com/images/post/1742889442176_19-min.webp",
//   "MI": "https://static.thelallantop.com/images/post/1742889442176_19-min.webp",
//   "पंजाब किंग्स": "https://static.thelallantop.com/images/post/1742889453210_20-min.webp",
//   "पंजाब": "https://static.thelallantop.com/images/post/1742889453210_20-min.webp",
//   "Punjab": "https://static.thelallantop.com/images/post/1742889453210_20-min.webp",
//   "PBKS": "https://static.thelallantop.com/images/post/1742889453210_20-min.webp",
//   "राजस्थान रॉयल्स": "https://static.thelallantop.com/images/post/1742889467544_21-min.webp",
//   "राजस्थान": "https://static.thelallantop.com/images/post/1742889467544_21-min.webp",
//   "Rajasthan": "https://static.thelallantop.com/images/post/1742889467544_21-min.webp",
//   "RR": "https://static.thelallantop.com/images/post/1742889467544_21-min.webp",
//   "रॉयल चैलेंजर्स बेंगलुरु": "https://static.thelallantop.com/images/post/1742889480923_22-min.webp",
//   "बेंगलुरु": "https://static.thelallantop.com/images/post/1742889480923_22-min.webp",
//   "Bangalore": "https://static.thelallantop.com/images/post/1742889480923_22-min.webp",
//   "RCB": "https://static.thelallantop.com/images/post/1742889480923_22-min.webp",
//   "सनराइजर्स हैदराबाद": "https://static.thelallantop.com/images/post/1742889496163_23-min.webp",
//   "सनराइज़र्स हैदराबाद" : "https://static.thelallantop.com/images/post/1742889496163_23-min.webp",
//   "हैदराबाद": "https://static.thelallantop.com/images/post/1742889496163_23-min.webp",
//   "Hyderabad": "https://static.thelallantop.com/images/post/1742889496163_23-min.webp",
//   "SRH": "https://static.thelallantop.com/images/post/1742889496163_23-min.webp"
// };

var TEAMS_OBJ = {
  "चेन्नई सुपर किंग्स": "https://static.thelallantop.com/images/post/1744787985046_15_(1)-min.webp",
  "चेन्नई": "https://static.thelallantop.com/images/post/1744787985046_15_(1)-min.webp",
  "Chennai": "https://static.thelallantop.com/images/post/1744787985046_15_(1)-min.webp",
  "CSK": "https://static.thelallantop.com/images/post/1744787985046_15_(1)-min.webp",
  "Chennai Super Kings": "https://static.thelallantop.com/images/post/1744787985046_15_(1)-min.webp",
  "दिल्ली कैपिटल्स": "https://static.thelallantop.com/images/post/1744787968045_11_(1)-min.webp",
  "दिल्ली": "https://static.thelallantop.com/images/post/1744787968045_11_(1)-min.webp",
  "Delhi": "https://static.thelallantop.com/images/post/1744787968045_11_(1)-min.webp",
  "DC": "https://static.thelallantop.com/images/post/1744787968045_11_(1)-min.webp",
  "Delhi Capitals": "https://static.thelallantop.com/images/post/1744787968045_11_(1)-min.webp",
  "गुजरात टाइटन्स": "https://static.thelallantop.com/images/post/1744790045390_16_(1)-min.webp",
  "गुजरात": "https://static.thelallantop.com/images/post/1744790045390_16_(1)-min.webp",
  "Gujarat": "https://static.thelallantop.com/images/post/1744790045390_16_(1)-min.webp",
  "GT": "https://static.thelallantop.com/images/post/1744790045390_16_(1)-min.webp",
  "Gujrat Titans": "https://static.thelallantop.com/images/post/1744790045390_16_(1)-min.webp",
  "कोलकाता नाइट राइडर्स": "https://static.thelallantop.com/images/post/1742889392428_17-min.webp",
  "कोलकाता": "https://static.thelallantop.com/images/post/1742889392428_17-min.webp",
  "Kolkata": "https://static.thelallantop.com/images/post/1742889392428_17-min.webp",
  "KKR": "https://static.thelallantop.com/images/post/1742889392428_17-min.webp",
  "Kolkata Knight Riders": "https://static.thelallantop.com/images/post/1742889392428_17-min.webp",
  "लखनऊ सुपर जायंट्स": "https://static.thelallantop.com/images/post/1744789962629_18_(1)-min.webp",
  "लखनऊ": "https://static.thelallantop.com/images/post/1744789962629_18_(1)-min.webp",
  "Lucknow": "https://static.thelallantop.com/images/post/1744789962629_18_(1)-min.webp",
  "LSG": "https://static.thelallantop.com/images/post/1744789962629_18_(1)-min.webp",
  "Lucknow Super Giants": "https://static.thelallantop.com/images/post/1744789962629_18_(1)-min.webp",
  "मुंबई इंडियंस": "https://static.thelallantop.com/images/post/1742889442176_19-min.webp",
  "मुंबई": "https://static.thelallantop.com/images/post/1742889442176_19-min.webp",
  "Mumbai": "https://static.thelallantop.com/images/post/1742889442176_19-min.webp",
  "MI": "https://static.thelallantop.com/images/post/1742889442176_19-min.webp",
  "Mumbai Indians": "https://static.thelallantop.com/images/post/1742889442176_19-min.webp",
  "पंजाब किंग्स": "https://static.thelallantop.com/images/post/1744790121059_20_(1)-min.webp",
  "पंजाब": "https://static.thelallantop.com/images/post/1744790121059_20_(1)-min.webp",
  "Punjab": "https://static.thelallantop.com/images/post/1744790121059_20_(1)-min.webp",
  "PBKS": "https://static.thelallantop.com/images/post/1744790121059_20_(1)-min.webp",
  "Punjab Kings": "https://static.thelallantop.com/images/post/1744790121059_20_(1)-min.webp",
  "राजस्थान रॉयल्स": "https://static.thelallantop.com/images/post/1744788001919_21_(1)-min.webp",
  "राजस्थान": "https://static.thelallantop.com/images/post/1744788001919_21_(1)-min.webp",
  "Rajasthan": "https://static.thelallantop.com/images/post/1744788001919_21_(1)-min.webp",
  "RR": "https://static.thelallantop.com/images/post/1744788001919_21_(1)-min.webp",
  "Rajasthan Royals": "https://static.thelallantop.com/images/post/1744788001919_21_(1)-min.webp",
  "रॉयल चैलेंजर्स बेंगलुरु": "https://static.thelallantop.com/images/post/1742889480923_22-min.webp",
  "बेंगलुरु": "https://static.thelallantop.com/images/post/1742889480923_22-min.webp",
  "Bangalore": "https://static.thelallantop.com/images/post/1742889480923_22-min.webp",
  "RCB": "https://static.thelallantop.com/images/post/1742889480923_22-min.webp",
  "Royal Challengers Bangalore": "https://static.thelallantop.com/images/post/1742889480923_22-min.webp",
  "सनराइजर्स हैदराबाद": "https://static.thelallantop.com/images/post/1744790216859_23_(1)-min.webp",
  "सनराइज़र्स हैदराबाद": "https://static.thelallantop.com/images/post/1744790216859_23_(1)-min.webp",
  "हैदराबाद": "https://static.thelallantop.com/images/post/1744790216859_23_(1)-min.webp",
  "Hyderabad": "https://static.thelallantop.com/images/post/1744790216859_23_(1)-min.webp",
  "SRH": "https://static.thelallantop.com/images/post/1744790216859_23_(1)-min.webp",
  "Sunrisers Hyderabad": "https://static.thelallantop.com/images/post/1744790216859_23_(1)-min.webp"
}; // export const VS_LINK = 'https://vsfeed.intoday.in/visualstories/feed/api.php?site=lallantop&type=hp&start=0&end=10'

var VS_LINK = 'https://vsfeed.intoday.in/visualstories/feed/api.php?site=lallantop&type=category&cat=sports&start=0&end=10';
var VALID_YEARS = (/* unused pure expression or super */ null && (["2024", "2023", "2022", "2021", "2020", "2019", "2018"]));
var VALID_CATEGORIES = (/* unused pure expression or super */ null && (["orange-cap-winner", "purple-cap-winner"]));
/**
* Sends an event to Google Analytics.
*
* @param {object} params - The event parameters.
* @param {string} params.eventName - The name of the event.
* @param {string} params.pageTitle - The title of the page where the event occurred.
* @param {string} params.pageLocation - The full URL of the page where the event occurred.
* @param {string} params.searchQuery - (Optional) The full URL of the page where the event occurred.
* @param {object} patams.object - Any other extra object along with the events.
*/

function sendGAEvent(_ref3) {
  var _process$env$NEXT_PUB;

  var _ref3$eventName = _ref3.eventName,
      eventName = _ref3$eventName === void 0 ? "" : _ref3$eventName,
      _ref3$pageTitle = _ref3.pageTitle,
      pageTitle = _ref3$pageTitle === void 0 ? "" : _ref3$pageTitle,
      _ref3$pageLocation = _ref3.pageLocation,
      pageLocation = _ref3$pageLocation === void 0 ? "" : _ref3$pageLocation,
      _ref3$propertyObject = _ref3.propertyObject,
      propertyObject = _ref3$propertyObject === void 0 ? {} : _ref3$propertyObject,
      _ref3$searchQuery = _ref3.searchQuery,
      searchQuery = _ref3$searchQuery === void 0 ? undefined : _ref3$searchQuery;
  // Check if gtag is defined on the window object
  var GACode = (_process$env$NEXT_PUB = "G-RXRPKR4310") !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "";

  if (typeof window.gtag === "function" && eventName && pageTitle && pageLocation) {
    // console.log("GA event SENT", {
    //   eventName,
    //   page_title: pageTitle,
    //   page_location: pageLocation,
    //   sent_to: GACode,
    // });
    var obj = _objectSpread({
      page_title: pageTitle,
      page_location: pageLocation,
      send_to: GACode
    }, propertyObject);

    if (searchQuery) {
      obj.search_query = searchQuery;
    }

    window.gtag("event", eventName, obj);
  } else {
    console.warn("gtag is not defined. Unable to send event to GA.");
  }
} // export default sendGAEvent;


var callGaEvent = function callGaEvent(_ref4) {
  var _window, _window$location;

  var eventName = _ref4.eventName,
      pageTitle = _ref4.pageTitle,
      _ref4$propertyObject = _ref4.propertyObject,
      propertyObject = _ref4$propertyObject === void 0 ? {} : _ref4$propertyObject;
  console.log("the event is called");
  sendGAEvent({
    eventName: eventName,
    pageTitle: pageTitle,
    pageLocation: (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.href,
    propertyObject: propertyObject
  });
};

/***/ })

}]);